require("events").EventEmitter.defaultMaxListeners = 0;

import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// create an axios instance
const service = axios.create({
    baseURL: '',//process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: true, // 跨域请求时发送Cookie
    timeout: 60000 * 60 * 2, // request timeout
});

// request interceptor
service.interceptors.request.use(
    async (config) => {
        // 在发送请求之前做些什么
        config.headers['Accept'] = "application/json";
        if (store.getters.currSubstation) {
          config.headers['cityCode'] = store.getters.currSubstation.id
        }
        // debugger  store.getters.token
        if (getToken()) {
            // 请求头中的刷新token
            // await axios.get('admin/auth/refreshToken', {params: {}, headers: {'Authorization': getToken(), 'Authorization-Refresh': getRefreshToken()}}).then(res => {
            //     let statusCode = res.data.code;
            //     if ( statusCode === "00010" || statusCode === "00011" || statusCode === "00012" || statusCode === "00013" || statusCode === "00014" || statusCode === "00015" ) {
            //         Message({ message: res.data.msg || "请求错误", type: "error", duration: 5 * 1000 });
            //         store.dispatch("user/resetToken").then(() => {
            //             location.reload();
            //         });

            //     } else {
            //         setToken(res.data.data.token);
            //     }
            // })
            // 让每个请求携带令牌 - ['Authorization']、['Authorization-Refresh'] 是自定义请求，请根据实际情况修改
            config.headers["Authorization"] = 'Bearer ' + getToken(); // 请求头中的token
            // config.headers['Authorization-Refresh'] = '';  // 请求头中的刷新token
            // config.headers['Authorization-Ip-Addr'] = returnCitySN["cip"]; // 客户端ip地址

        }
        return config;
    },
    (error) => {
        // do something with request error
        return Promise.reject(error);
    }
);


// response interceptor
service.interceptors.response.use(
    /**
     * 如果您想获取http信息，如头或状态
     * 请返回response=>response
     */

    /**
     * 通过自定义代码确定请求状态
     * 您还可以通过HTTP状态代码来判断状态
     */
    (response) => {
        const res = response.data;
        const targetUrl = response.request.responseURL;

        if (targetUrl.includes('/downloadFile')) {
            return res
        }

        if (targetUrl.includes('backEnt/queryEntApprovingTotal')) {
            return res
        }

        if (response.headers['content-type'] === 'image/png') {
            return res;
        }
        if(res.code === 500&&(res.msg .startsWith("504 GATEWAY_TIMEOUT")||res.msg .startsWith("服务未找到"))){
            return null;
        }
        // 如果自定义代码不是200，则判断为错误。
        if ( Object.prototype.toString.call(res) === '[object Object]' && res.code !== 200) {
            // Message({ message: res.msg || "网络错误", type: "error", duration: 5 * 1000 });

            /**
             * 401 - JWT_TOKEN_EXPIRED - Token已过期
             */
            if ( res.code === 401 ) {
                store.dispatch("user/loginOut").then(() => {
                    location.reload();
                });
                Message({ message: res.msg || "请求错误", type: "error", duration: 5 * 1000 });
            } else {
                Message({ message: res.msg || "请求错误", type: "error", duration: 5 * 1000 });
            }
            return Promise.reject(new Error(res.msg || "Error"));
        } else {
            return res;
        }
    },
    (error) => {
        Message({ message: error.msg || "网络错误", type: "error", duration: 5 * 1000 });
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js